import {
  IFetchCompetitionDetailSuccessAction,
  IFetchCompetitionListSuccessAction,
  ISetModalDataAction,
  ISetSelectedCompetitionAction,
} from './CompetitionAction';

import { Action } from 'redux';

export const initialState: any = {
  list: [],
  selectedCompetition: '',
  selectedCompetitionData: {},
  additionalExpenseModalAction: 'register',
};
export default function CompetitionReducer(
  state = initialState,
  action: Action
) {
  const newState = Object.assign({}, state);
  switch (action.type) {
    case 'FETCH_COMPETITION_LIST_FINISHED': {
      const fetchCompetitionListSuccessAction = action as IFetchCompetitionListSuccessAction;
      newState.list = fetchCompetitionListSuccessAction.data;
      return { ...newState };
    }
    case 'FETCH_COMPETITION_DETAIL_FINISHED': {
      const fetchCompetitionDetailSuccessAction = action as IFetchCompetitionDetailSuccessAction;
      newState.selectedCompetitionData =
        fetchCompetitionDetailSuccessAction.data;
      return { ...newState };
    }
    case 'SET_SELECTED_COMPETITION': {
      const setSelectedCompetitionAction = action as ISetSelectedCompetitionAction;
      newState.selectedCompetition = setSelectedCompetitionAction.id;
      return { ...newState };
    }
    case 'SET_COMPETITION_MODAL_DATA': {
      const setModalDataAction = action as ISetModalDataAction;
      newState.additionalExpenseModalAction = setModalDataAction.action;
      newState.selectedCompetitionData = setModalDataAction.data;
      return { ...newState };
    }
  }
  return state;
}
